import React from 'react';
import { Link } from 'react-router-dom';

const Events = () => {
  const images = [
    '/images/cater-1.jpg',
    '/images/cater2.jpg',
    '/images/cater3.jpg',
    '/images/cater4.jpg',
  ];

  return (
    <div className="relative min-h-screen bg-gray-900 text-white">


      <section className="py-16">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <h2 className="font-playfair text-4xl md:text-5xl mb-6">WE CATER AND ACCEPT EVENTS</h2>
          <p className="max-w-2xl mx-auto text-gray-200 mb-8">We provide full service catering and event hosting. Below are some photos of our venue and past events.</p>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
            {images.map((src, idx) => (
              <div key={idx} className="overflow-hidden rounded-md">
                <img src={src} alt={`Event ${idx+1}`} className="w-full h-56 object-cover block" />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Hero / Event booking section (moved below the gallery as requested) */}
      <section className="relative bg-cover bg-center mt-12" style={{ backgroundImage: `url('/images/cater-1.jpg')` }}>
        <div className="absolute inset-0 bg-black/60"></div>
        <div className="max-w-7xl mx-auto px-6 py-28 relative z-10">
          <div className="max-w-3xl text-left">
            <h1 className="text-4xl md:text-5xl font-playfair text-white leading-tight mb-4">CATERING SERVICES AND
              <br />EVENT BOOKING</h1>
            <p className="text-gray-200 mb-6">We provide full-service catering and event hosting. Tell us your vision and we’ll handle the rest — from menu planning to venue setup and day-of coordination.</p>
            <Link to="/booking?room=event" className="inline-block bg-amber-700 text-white px-5 py-2 rounded shadow hover:opacity-95">BOOK AN EVENT</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Events;
